module.exports = __webpack_public_path__ + "static/media/ic_info_circle_outlined.0673af0e.svg";